// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Faker from "faker";

function findName(firstName, lastName, gender, param) {
  return Curry._3(Faker.name.findName, firstName, lastName, gender);
}

function firstName(gender, param) {
  return Curry._1(Faker.name.firstName, gender);
}

function lastName(gender, param) {
  return Curry._1(Faker.name.lastName, gender);
}

function prefix(gender, param) {
  return Curry._1(Faker.name.prefix, gender);
}

function suffix(param) {
  return Curry._1(Faker.name.suffix, undefined);
}

function title(param) {
  return Curry._1(Faker.name.title, undefined);
}

function jobArea(param) {
  return Curry._1(Faker.name.jobArea, undefined);
}

function jobType(param) {
  return Curry._1(Faker.name.jobType, undefined);
}

export { findName, firstName, lastName, prefix, suffix, title, jobArea, jobType };
/* faker Not a pure module */